<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export default {
  name: 'FclDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '22010011' },
    showPriceNo: { type: Boolean, default: true },
    showApprove: { type: Boolean, default: false },
    showHistory: { type: Boolean, default: false },
    view: { type: Number, default: 4 },
    filter: { type: Object, default: () => {} },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      URL,
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      remarkChange: false,
      authedLevel: 99,
      proxy: {},
      filterJson: {},
      showDetail: false,
      fullscreenLoading: false,
      gridParams: {},
      gridApi: null,
      priceTypes: PriceConstant.PRICE_TYPES,
      columnDefs: [
        {
          headerName: ' ', checkboxSelection: true, maxWidth: 40,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200, hide: !this.showPriceNo, suppressColumnsToolPanel: !this.showPriceNo },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Pricing.CabinState'), field: 'priceState', colId: 'priceState', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.PriceTrend'), field: 'trend', colId: 'trend', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.trendLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.shareColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200
        },
        {
          headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200
        },
        {
          headerName: '20\'', field: 'cost20', colId: 'cost20', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc(this.view, params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '40\'', field: 'cost40', colId: 'cost40', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc(this.view, params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '40\' HC', field: 'costhc', colId: 'costhc', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc(this.view, params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '40\' NOR', field: 'cost40nor', colId: 'cost40nor', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc(this.view, params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: '45\'', field: 'cost45', colId: 'cost45', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc(this.view, params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.COST_VAT'), field: 'costVat', colId: 'costVat', width: 200
        },
        {
          headerName: this.$t('Pricing.SELL_VAT'), field: 'sellVat', colId: 'sellVat', width: 200
        },
        {
          headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Pricing.ContractNo'), field: 'contractNo', colId: 'contractNo', width: 200
        },
        { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200 },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.Source'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'frequency', colId: 'frequency8', width: 200,
          valueFormatter: (params) => {
            params.data.frequency = PriceUtils.frequencyLabelFunc(params.data, 'frequency')
            return params.data.frequency
          } },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.value)
          } },
        { headerName: this.$t('Pricing.ServiceMode'), field: 'serviceMode', colId: 'serviceMode', width: 200 },
        { headerName: this.$t('Pricing.ServiceCode'), field: 'serviceCode', colId: 'serviceCode', width: 200 },
        { headerName: this.$t('SeaExport.CargoType'), field: 'cargoType', colId: 'cargoType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Pricing.Commodity'), field: 'commodity', colId: 'commodity', width: 200 },
        { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
        { headerName: this.$t('Pricing.FreeTime'), field: 'freeTime', colId: 'freeTime', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnclnTimeFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.SaleState'), field: 'saleState', colId: 'saleState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.saleStateLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Pricing.EffectiveDateType'), field: 'dateTypeEffective', colId: 'dateTypeEffective', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.priceFclDateTypeLabelFunction(params.value)
          } },
        { headerName: this.$t('Pricing.ExpirationDateType'), field: 'dateTypeExpiration', colId: 'dateTypeExpiration', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.priceFclDateTypeLabelFunction(params.value)
          } },
        { headerName: this.$t('Pricing.ReceivingInstructions'), field: 'receivingInstructions', colId: 'receivingInstructions', width: 200 },
        { headerName: this.$t('Pricing.DepartureDay2'), field: 'frequency8', colId: 'frequency8_1', width: 200, hide: true,
          valueFormatter: (params) => {
            return params.value ? params.value.replaceAll(',', '/') : ''
          } },
        { headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200 },
        { headerName: this.$t('Pricing.TransportMode'), field: 'transportMode', colId: 'transportMode', width: 200 },
        { headerName: this.$t('Pricing.SubContractNo'), field: 'subContractNo', colId: 'subContractNo', width: 200 },
        { headerName: this.$t('Pricing.NA'), field: 'na', colId: 'na', width: 200 },
        { headerName: this.$t('Pricing.NaCode'), field: 'naCode', colId: 'naCode', width: 200 },
        { headerName: this.$t('Pricing.amsEns'), field: 'amsEns', colId: 'amsEns', width: 200 },
        { headerName: this.$t('Pricing.overloadRemarks'), field: 'overLoadRemarks', colId: 'overLoadRemarks', width: 200 },
        { headerName: this.$t('Pricing.DocumentId'), field: 'templateFileId', colId: 'templateFileId', width: 200 },
        { headerName: this.$t('Pricing.customSpecs'), field: 'customSpecs', colId: 'customSpecs', width: 200, hide: true },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200, hide: true },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        // { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
        //   hide: true,
        //   cellRenderer: (params) => {
        //     return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
        //   } },
        { headerName: this.$t('CargoMsg.Cargo_PriceUpdateUser'), field: 'updateUserId', colId: 'updateUserId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EffectiveDate'), field: 'dateEffective', colId: 'dateEffective', width: 200,
          hide: !this.showHistory, suppressColumnsToolPanel: !this.showHistory,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ExpirationDate'), field: 'dateExpiration', colId: 'dateExpiration', width: 200,
          hide: !this.showHistory, suppressColumnsToolPanel: !this.showHistory,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.closingDayFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ROD'), field: 'region', colId: 'region', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.regionForPriceFclLabelFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.priceTypes, params.value)
          }
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
        },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
        },
        { headerName: '20\' NOR', field: 'cost20nor', colId: 'cost20nor', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc(this.view, params, this.filter.level, this.filter.currency, this.authedLevel)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
    rowData() {
      this.txtRemarks = ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridOptions.onRowClicked = this.onRowClickedEvent
      this.authedLevel = this.getAuthedLevel()
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PFDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PFDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PFDA_*_2'])) {
        return 2
      }
      return 99
    },
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
      this.txtRemarks = data.remarks
    }
  }
}
</script>
<style lang="scss">
</style>

